<template>
  <div class="modal sign-modal">
    <div class="overlay"  @click="$emit('closeSignInModal')"></div>
    <div class="wrapper">
      <img class="close" @click="$emit('closeSignInModal')" src="./../assets/close.svg"/>
      <div class="container">
        <!-- <div class="left">
          <transition name="fade">
            <div class="left-wrapper login-content" v-if="loginContentVisible">
              <div class="title">Don't have account?</div>
              <div class="link switch-register" @click="switchToRegister()">Please register</div>
            </div>
          </transition>
          <transition name="fade">
            <div class="left-wrapper register-content" v-if="registerContentVisible || forgotPassContentVisible">
              <div class="title">Have account?</div>
              <div class="link switch-login" @click="switchToLogin()">Login</div>
            </div>
          </transition>
        </div> -->
        <div class="form">
          <div class="form-wrapper">
            <div :class="['form-fields register-content', {'hidden': !registerContentVisible}]">
              <div class="form-fields-wrapper">
                <div class="title small">{{ $t('Registration') }}</div>
                <label>
                  <div class="desc">*{{ $t('First name') }}</div>
                  <input type="text" :placeholder="$t('First name')" v-model="name"/>
                </label>
                <label>
                  <div class="desc">*{{ $t('Last Name') }}</div>
                  <input type="text" :placeholder="$t('Last Name')" v-model="surname"/>
                </label>
                <label>
                  <div class="desc">*{{ $t('Email') }}</div>
                  <input type="email" :placeholder="$t('Email')" v-model="email"/>
                </label>
                <label>
                  <div class="desc">*{{ $t('Phone') }}</div>
                  <input type="tel" :placeholder="$t('Phone')" v-model="phone"/>
                </label>
                <label>
                  <div class="desc">*{{ $t('Password') }}</div>
                  <input type="password" :placeholder="$t('Password')" v-model="pass"/>
                </label>
                <label>
                  <div class="desc">*{{ $t('Confirm Password') }}</div>
                  <input type="password" :placeholder="$t('Confirm Password')" v-model="passConfirm"/>
                </label>
                <div class="cta-container">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms"/>
                        <div class="checkbox"></div>
                        <span class="title">{{ $t('I agree with') }} </span>
                        <a @click="$parent.goToPage('privacy', true)" class="title"> {{ $t('privacy policy') }}</a>
                        <span class="title"> {{ $t('and') }} </span>
                        <a @click="$parent.goToPage('terms', true)" class="title"> {{ $t('terms and conditions') }}</a>
                      </div>
                    </label>
                  </div>
                  <button :class="['button', {'disabled': !requiredRegisterFieldsAreFilled}]" @click="submitRegister">
                    <span>{{ $t('Register now') }}</span>
                  </button>
                </div>
                <div class="modal-bottom">
                  <div class="desc">{{ $t('Have account?') }}</div>
                  <div class="link switch-login" @click="switchToLogin()">{{ $t('Login now') }}</div>
                </div>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                </transition>
              </div>
            </div>
            <div :class="['form-fields login-content', {'hidden': !loginContentVisible}]">
              <div class="form-fields-wrapper">
                <div class="title small">{{ $t('Login') }}</div>
                <label>
                  <div class="desc">{{ $t('E-mail:') }}</div>
                  <input type="email" :placeholder="$t('Email')" v-model="email"/>
                </label>
                <label>
                  <div class="desc">{{ $t('E-mail:') }}Password:</div>
                  <input type="password" :placeholder="$t('Password')" v-model="pass"/>
                </label>
                <div class="cta-container">
                  <div class="link" @click="switchToforgotPass">{{ $t('Forgot password?') }}</div>
                  <button class="button" @click="submitLogin">
                    <span>{{ $t('Login Now') }}</span>
                  </button>
                </div>
                <div class="modal-bottom">
                  <div class="desc">{{ $t('Don\'t have account?') }}</div>
                  <div class="link switch-register" @click="switchToRegister()">{{ $t('Register now') }}</div>
                </div>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                </transition>
              </div>
            </div>
            <div :class="['form-fields forgot-pass-content', {'hidden': !forgotPassContentVisible}]">
              <div class="form-fields-wrapper">
                <div class="title small">{{ $t('Forgot password?') }}</div>
                <label>
                  <div class="desc">{{ $t('E-mail:') }}</div>
                  <input type="email" :placeholder="$t('Email')" v-model="email"/>
                </label>
                <div class="cta-container">
                  <button class="button" @click="submitForgotPass">
                    <span>{{ $t('Recover') }}</span>
                  </button>
                </div>
                <div class="modal-bottom">
                  <div class="desc">{{ $t('Have account?') }}</div>
                  <div class="link switch-login" @click="switchToLogin()">{{ $t('Login') }}</div>
                </div>
                <transition name="fade">
                  <div v-if="$parent.successMessage" class="desc green">{{$parent.successMessage}}</div>
                </transition>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SignInModal',
  props: [],
  components: {
  },
  data: function() {
    return {
      loginContentVisible: true,
      registerContentVisible: false,
      forgotPassContentVisible: false,
      profile: {},
      email: '',
      pass: '',
      name: '',
      surname: '',
      phone: '',
      passConfirm: '',
      terms: false
    }
  },
  mounted() {
    
  },
  computed: {
    requiredRegisterFieldsAreFilled() {
      let fieldsAreFilled;
      if(
        this.name && this.surname  && this.phone && 
        this.email && this.pass && this.passConfirm
        && this.terms 
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    }
  },
  methods: {
    closeSignInModal() {
      this.$emit('closeSignInModal')
    },
    switchToforgotPass() {
      this.$parent.clearError();
      setTimeout(()=> {
        this.loginContentVisible = false;
        this.forgotPassContentVisible = true;
      }, 100)
    },
    switchToRegister() {
      this.$parent.clearError();
      setTimeout(()=> {
        this.loginContentVisible = false;
        this.registerContentVisible = true;
      }, 100)
    
    },
    switchToLogin() {
      this.$parent.clearError();
      setTimeout(()=> {
        this.forgotPassContentVisible = false;
        this.registerContentVisible = false;
        this.loginContentVisible = true;
      }, 100)
    },
    submitLogin() {
      let loginData = {
        "username": this.email,
        "password": this.pass
      }
      this.$emit('login', loginData)
    },
    submitRegister() {
      let regData = {
        "name": this.name,
        "surname": this.surname,
        "email": this.email,
        "phone": this.phone,
        "password": this.pass,
        "passConfirm": this.passConfirm
      }
        this.$emit('registration', regData)
    },
    submitForgotPass() {
      let data = {
        "email": this.email
      }
      this.$emit('forgotPass', data)
    }
  }
}
</script>